import { render } from "./BaseItem.vue?vue&type=template&id=f795eed0&scoped=true"
import script from "./BaseItem.vue?vue&type=script&lang=js"
export * from "./BaseItem.vue?vue&type=script&lang=js"

import "./BaseItem.vue?vue&type=style&index=0&id=f795eed0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f795eed0"]])

export default __exports__